import { render, staticRenderFns } from "./menuComponents.vue?vue&type=template&id=c483ed5a&scoped=true&"
import script from "./menuComponents.vue?vue&type=script&lang=js&"
export * from "./menuComponents.vue?vue&type=script&lang=js&"
import style0 from "./menuComponents.vue?vue&type=style&index=0&id=c483ed5a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c483ed5a",
  null
  
)

export default component.exports